import { Location } from '@angular/common';
import { Component, HostListener, inject, OnInit, signal, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RegisterAccountingModelComponent } from '../register-accounting-model/register-accounting-model.component';

@Component({
  selector: 'app-accounting-model',
  templateUrl: './accounting-model.component.html',
  styleUrls: ['./accounting-model.component.scss'],
  standalone: false
})
export class AccountingModelComponent implements OnInit {

  private readonly headerService = inject(HeaderService);
  private readonly location = inject(Location);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);

  @ViewChild(RegisterAccountingModelComponent) registerAccountingModelComponent?: RegisterAccountingModelComponent;

  readonly tabs = ['Captura de Datos', 'Configuración Concepto', 'Consulta Concepto - Familia'];
  readonly activeTab = signal<string>(this.tabs[0]);

  isOpened: string | undefined = undefined;
  nameWindow: string = 'Modelos Contables';
  projectName = ProjectName.projectName;
  url: string = 'accounting-model';

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.validateOpenWindow();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  createNewRegister() {
    this.activeTab.set(this.tabs[0]);
    this.registerAccountingModelComponent?.createAccountingModel();
  }

  private getRegisterAccountingModelUrl(): string {
    const accountingModelId = this.registerAccountingModelComponent?.accountingModelId ?? 0;

    if (accountingModelId && accountingModelId !== 0) {
      return `/accounting-model/register/${accountingModelId}`;
    }

    return '/accounting-model/register';
  }

  selectTab(tab: string) {
    this.activeTab.set(tab);
    if (tab === this.tabs[0]) {
      this.location.replaceState(this.getRegisterAccountingModelUrl());
    } else {
      this.location.replaceState('/accounting-model');
    }
  }

  async validateOpenWindow() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
  }

}
